import { defineNuxtPlugin, useRoute, useRouter } from "#app";
import { markRaw } from "vue";

export const routerPlugin = {
    get route() {
        return useRoute();
    },
    get router() {
        return useRouter();
    },
};

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.provide("routerPlugin", markRaw(routerPlugin));
});